import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigate } from './navigation';

/**
 * Registers react-router's navigate function for imperative routing outside components.
 */
const NavigationProvider = () => {
    const navigate = useNavigate();

    useEffect(() => {
        setNavigate(navigate);
    }, [navigate]);

    return null;
};

export default NavigationProvider;
